import { GET, DELETE, PUT } from '../request'

export const getFacturasMes = ({ mes, centro }) =>
  GET('/api/core/interno/documentacion/factura/list', { mes, centro })

export const deleteFactura = ({ id }) =>
  DELETE('/api/core/interno/documentacion/factura', { id })

export const updateFactura = ({
  id,
  nombre,
  identificacion_cliente,
  concepto
}) =>
  PUT('/api/core/interno/documentacion/factura', {
    id,
    nombre,
    identificacion_cliente,
    concepto
  })
